import {CDN_URL} from "utils/env/env"

export default function getUrl(image: string) {
    return image.replace("{{CDN_URL}}", CDN_URL)
}